/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as UserAPIs from '../services/UserAPIs';
import * as types from '../constants/ActionTypes';

import { logout } from 'FetchAPIs';

const getCurrentUserRequest = () => ({
  type: types.GET_CURRENT_USER_REQUEST,
});

const getCurrentUserSuccess = data => ({
  type: types.GET_CURRENT_USER_SUCCESS,
  data,
});

const getCurrentUserFailure = error => ({
  type: types.GET_CURRENT_USER_FAILURE,
  error,
});

export const getCurrentUser =
  tenantid =>
  (dispatch, getState, { dataCache }) => {
    dispatch(getCurrentUserRequest());
    return UserAPIs.getCurrentUser(tenantid).then(
      json => {
        dataCache.set('currentUser', json);
        return dispatch(getCurrentUserSuccess(json));
      },
      error => {
        dispatch(getCurrentUserFailure(error));
        throw error;
      }
    );
  };

const getCurrentUserResourcesRequest = () => ({
  type: types.GET_CURRENT_USER_RESOURCES_REQUEST,
});

const getCurrentUserResourcesSuccess = data => ({
  type: types.GET_CURRENT_USER_RESOURCES_SUCCESS,
  data,
});

const getCurrentUserResourcesFailure = error => ({
  type: types.GET_CURRENT_USER_RESOURCES_FAILURE,
  error,
});

export const getCurrentUserResources =
  userId =>
  (dispatch, getState, { dataCache }) => {
    dispatch(getCurrentUserResourcesRequest());
    return UserAPIs.getCurrentUserResources(userId).then(
      json => {
        dataCache.set('currentUserResources', json);
        return dispatch(getCurrentUserResourcesSuccess(json));
      },
      error => {
        dispatch(getCurrentUserResourcesFailure(error));
        throw error;
      }
    );
  };

const logoutCurrentUserRequest = () => ({
  type: types.LOGOUT_CURRENT_USER_REQUEST,
});

const logoutCurrentUserSuccess = data => ({
  type: types.LOGOUT_CURRENT_USER_SUCCESS,
  data,
});

const logoutCurrentUserFailure = error => ({
  type: types.LOGOUT_CURRENT_USER_FAILURE,
  error,
});

export const logoutCurrentUser = ssoLogoutURL => dispatch => {
  dispatch(logoutCurrentUserRequest());

  return Promise.all(
    ssoLogoutURL
      .split(',') // support multiple ssoLogoutURLs  https://w3.ibm.com/w3publisher/ibmid-home/adoption-guide/logout see the SLO workaround section
      .map(logoutURL =>
        fetch(logoutURL, {
          mode: 'no-cors',
          credentials: 'include',
        })
      )
  ).finally(() =>
    logout().then(
      json => dispatch(logoutCurrentUserSuccess(json)),
      error => {
        dispatch(logoutCurrentUserFailure(error));
        throw error;
      }
    )
  );
};

// getTenantsRelatedToUser gives back all tenants where the given email adress is member/ owner of

const getTenantsRelatedToUserRequest = () => ({
  type: types.GET_TENANTS_RELATED_TO_USER_REQUEST,
});

const getTenantsRelatedToUserSuccess = data => ({
  type: types.GET_TENANTS_RELATED_TO_USER_SUCCESS,
  data,
});
const getTenantsRelatedToUserFailure = error => ({
  type: types.GET_TENANTS_RELATED_TO_USER_FAILURE,
  error,
});

export const getTenantsRelatedToUser = () => dispatch => {
  dispatch(getTenantsRelatedToUserRequest());
  return UserAPIs.getTenantsRelatedToUser().then(
    json => dispatch(getTenantsRelatedToUserSuccess(json)),
    error => {
      dispatch(getTenantsRelatedToUserFailure(error));
      throw error;
    }
  );
};
